import type { QueryClient } from '@tanstack/react-query';
import { strategyKeys } from '../queryKeys';

/**
 * Everything computed from the practice-data uploads: refresh it when an
 * upload finishes, fails or is removed. Market share, the opportunity scores,
 * the overview and the insights' "inputs changed" flag all read the uploads;
 * refreshing only the upload cards left them showing the old figures until
 * their cache expired.
 */
export function invalidateUploadDependents(queryClient: QueryClient, locationId: string): void {
  for (const queryKey of [
    strategyKeys.uploads(locationId),
    strategyKeys.enrichment(locationId),
    strategyKeys.lifecycle(locationId),
    strategyKeys.marketIntel(locationId),
    strategyKeys.overview(locationId),
    // Prefix: every version's insights.
    strategyKeys.insights(locationId),
  ]) {
    void queryClient.invalidateQueries({ queryKey });
  }
}
